<template>
  <div>
    <stepheader :step="step" />
    <div
      id="wizard2-p-0"
      role="tabpanel"
      aria-labelledby="wizard2-h-0"
      class="body current"
      aria-hidden="false"
      style=""
    >
      <div class="row">
        <div class="col-12 text-center">
          <span
            class="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Stiamo verificando lo stato del dispositivo...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "findmyphone",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  components: {},
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
    fireaction: function (action, nextstep) {
      switch (action) {
        default:
          this.$emit("goto", nextstep);
          break;
      }
    },
    loaddata: function () {
      axios
        .get("tickets/checkfindmyphone/" + this.ticket.idimeI_SKU)
        .then((result) => {
          console.log(`findmyphone = ${result.data.data}`);
          if (result.data.data == "OFF") {
            var nextstep = this.step.buttons.filter(
              (x) => x.action == "next"
            )[0];
            this.$emit("goto", nextstep.nextstep);
          } else {
            var nextstep = this.step.buttons.filter(
              (x) => x.action == "error"
            )[0];
            this.$emit("goto", nextstep);
          }
        });
    },
  },
};
</script>